























import { Vue, Component, Prop } from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class BaseButton extends Vue {
  @Prop({ default: 'primary' }) type: string;
  @Prop({ default: 'small' }) size: string;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: false }) loaded: boolean;
  @Prop({ default: false }) loading: boolean;

  get disabledButton() {
    return this.disabled || this.loading || this.loaded;
  }

  get hideText() {
    return this.loaded || this.loading;
  }
}
